import { ListItem } from "client/Components";
import {
	PropsWithChildren,
	ReactElement
} from "react";

export type HubListButtonProps = {
	onClick(): void;
	trackingId: string;
};

export const HubListButton = (props: PropsWithChildren<HubListButtonProps>): ReactElement => {
	const {
		onClick,
		children,
		trackingId
	} = props;

	return (
		<ListItem trackingId={trackingId}>
			<ListItem.Content onClick={onClick}>
				<ListItem.Title variant="link">
					{children}
				</ListItem.Title>
			</ListItem.Content>
		</ListItem>
	);
};
HubListButton.displayName = "HubListButton";